// frontend/src/pages/MatchScoring/InningsEndModal.js
//
// Simple reason picker for manual innings end. Captain decides when innings
// is over (no auto-firing). On confirm, parent calls
// POST /scorer/matches/:matchId/innings/:inningsId/end with end_reason.
//
// Reasons map directly to the backend enum:
//   ['all_out','overs_done','target_reached','declared','abandoned']

import React, { useState } from 'react';

const REASONS = [
  { v: 'all_out',        label: 'All out',         hint: 'Last batter is out' },
  { v: 'overs_done',     label: 'Overs done',      hint: 'Allotted overs bowled' },
  { v: 'target_reached', label: 'Target reached',  hint: 'Chasing side won' },
  { v: 'declared',       label: 'Declared',        hint: 'Captain ends innings early' },
  { v: 'abandoned',      label: 'Abandoned',       hint: 'Rain / darkness / other' },
];

export default function InningsEndModal({ inningsNumber, onCancel, onConfirm, busy }) {
  const [reason, setReason] = useState('overs_done');

  return (
    <div className="sc-modal-backdrop" onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="sc-modal">
        <div className="sc-modal-body">
          <h3>End innings {inningsNumber}?</h3>
          <div style={{ fontSize: 12, color: 'var(--sc-text-mute)', marginTop: -8, marginBottom: 12 }}>
            Pick the reason. The scorecard freezes for this innings; you can still edit individual balls afterwards.
          </div>

          <h4>Reason</h4>
          <div className="sc-chip-row">
            {REASONS.map(r => (
              <button
                key={r.v}
                className={`sc-chip ${reason === r.v ? 'sc-active' : ''}`}
                onClick={() => setReason(r.v)}
              >
                {r.label}
              </button>
            ))}
          </div>
          <div style={{ fontSize: 11, color: 'var(--sc-text-mute)', marginTop: 6 }}>
            {REASONS.find(r => r.v === reason)?.hint}
          </div>
        </div>

        <div className="sc-modal-actions">
          <button className="sc-submit" disabled={busy} onClick={() => onConfirm(reason)}>
            {busy ? 'Ending…' : `End innings ${inningsNumber}`}
          </button>
          <button className="sc-cancel" onClick={onCancel} disabled={busy}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
